<div [formGroup]="form" class="setting-section-container shadow-sm">
  <div class="form-group pt-1 d-flex">
    <div class="align-items-baseline">
      <input type="checkbox" id="aiCoachingEnabled" formControlName="aiCoachingEnabled" />
    </div>
    <div class="col d-block ps-1 pe-0">
      <label for="aiCoachingEnabled">
        {{ 'Settings::AICoaching:Enable' | abpLocalization }}
      </label>
      @if (form.get('aiCoachingEnabled')?.value) {
        <div class="form-group pt-2">
          <div>
            <label for="aiCoachingStartDate">
              {{ 'Settings::AICoaching:StartDate' | abpLocalization }}
            </label>
            <ca-datetime-picker
              formControlName="aiCoachingStartDate"
              [minDate]="startDate"
              [hideTime]="true"
              (changed)="onDateChange()"></ca-datetime-picker>
            <small class="form-text text-muted ms-1">
              {{ 'Settings::AICoaching:StartDate:Description' | abpLocalization }}
            </small>
          </div>
        </div>
        <div class="form-group pt-2">
          <label for="aiCoachingPeriod" class="form-label">
            {{ 'Settings::AICoaching:Period' | abpLocalization }}
          </label>
          <ca-select [class]="'below-all'" formControlName="aiCoachingPeriod" id="aiCoachingPeriod">
            <ca-option
              *ngFor="let aiCoachingPeriodType of aiCoachingPeriodTypes"
              [value]="aiCoachingPeriodType.value.toString()">
              {{
                'CoachingAndTraining::AICoaching.Period.Type.' + aiCoachingPeriodType.key
                  | abpLocalization
              }}
            </ca-option>
          </ca-select>
          <small class="form-text text-muted ms-1">
            {{ 'Settings::AICoaching:Period:Description' | abpLocalization }}
          </small>
        </div>
        <div class="form-group pt-2">
          <div class="radio-group d-flex">
            <label for="aiCoachingTargetSelection" class="form-label">
              @if (
                form.get('aiCoachingTargetSelection')?.value == targetSelectionType.User.toString()
              ) {
                {{ 'Settings::AICoaching:Target:Agents' | abpLocalization }}
              }
              @if (
                form.get('aiCoachingTargetSelection')?.value ==
                targetSelectionType.Department.toString()
              ) {
                {{ 'Settings::AICoaching:Target:Departments' | abpLocalization }}
              }
              @if (
                form.get('aiCoachingTargetSelection')?.value ==
                targetSelectionType.UserGroup.toString()
              ) {
                {{ 'Settings::AICoaching:Target:UserGroups' | abpLocalization }}
              }
            </label>
            @if (userGroupSettingEnabled) {
              <input
                id="userGroupRadio"
                type="radio"
                class="ms-2 mb-2"
                [value]="targetSelectionType.UserGroup.toString()"
                formControlName="aiCoachingTargetSelection" />
              <label for="userGroupRadio" class="radio-label ms-2">
                {{ '::TargetSelection.Type.UserGroup' | abpLocalization }}
              </label>
            }
            @if (!userGroupSettingEnabled) {
              <input
                id="departmentRadio"
                type="radio"
                class="ms-2 mb-2"
                [value]="targetSelectionType.Department.toString()"
                formControlName="aiCoachingTargetSelection" />
              <label for="departmentRadio" class="radio-label ms-2">
                {{ '::TargetSelection.Type.Department' | abpLocalization }}
              </label>
            }
            <input
              id="agentRadio"
              type="radio"
              class="ms-2 mb-2"
              [value]="targetSelectionType.User.toString()"
              formControlName="aiCoachingTargetSelection" />
            <label for="agentRadio" class="radio-label ms-2">
              {{ '::TargetSelection.Type.User' | abpLocalization }}
            </label>
          </div>
        </div>
        <div class="form-group pt-2">
          <div
            class="form-group"
            [hidden]="
              form.get('aiCoachingTargetSelection')?.value !=
              targetSelectionType.Department.toString()
            ">
            <ca-dropdown-selector-wrapper
              [buttonString]="'QualityManagement::PickConversationsFromDepartments'"
              [selectionTemplate]="dropdownTemplate"
              [selectionExceptTemplate]="dropdownExceptTemplate"
              [selections]="selectedDepartments"
              [except]="false">
              <ca-department-selector
                formControlName="aiCoachingDepartments"
                [hideFilterMode]="true"></ca-department-selector>
            </ca-dropdown-selector-wrapper>
          </div>
          <div
            class="form-group"
            [hidden]="
              form.get('aiCoachingTargetSelection')?.value != targetSelectionType.User.toString()
            ">
            <ca-user-popup-selector
              userType="all"
              formControlName="aiCoachingAgents"
              [itemsPerPage]="25"
              [addClassToDropdown]="'fill-width'"
              [dropdownPosition]="'bottom'"
              [status]="'active'"></ca-user-popup-selector>
          </div>
          <div
            class="form-group"
            [hidden]="
              form.get('aiCoachingTargetSelection')?.value !=
              targetSelectionType.UserGroup.toString()
            ">
            <ca-dropdown-selector
              id="userGroupSelector"
              [url]="userGroupSelectorOptions.url"
              [filters]="userGroupSelectorFilters"
              [useSimpleFilter]="userGroupSelectorOptions.useSimpleFilter"
              [pageSize]="userGroupSelectorOptions.pageSize"
              [itemTemplate]="dropdownTemplate"
              [queryOperator]="userGroupSelectorOptions.queryOperator"
              [queryField]="userGroupSelectorOptions.queryField"
              [emptyText]="userGroupSelectorOptions.emptyText"
              [multiple]="userGroupSelectorOptions.multiple"
              [selectorPosition]="userGroupSelectorOptions.selectorPosition"
              [selectionTemplate]="dropdownSelectionTemplate"
              [listSelectionTemplate]="dropdownListSelectionTemplate"
              [buttonCls]="'btn btn-sm dropdown-from-selector-button'"
              [styles]="{ width: '100%' }"
              [listStyles]="{ height: '350px' }"
              formControlName="aiCoachingUserGroups"></ca-dropdown-selector>
          </div>
          <small class="form-text text-muted ms-1">
            {{ 'Settings::AICoaching:Target:Description' | abpLocalization }}
          </small>
        </div>
        <div class="form-group pt-2">
          <label for="aiCoachingMaxConversationCountPerAgent" class="form-label">
            {{ 'Settings::AICoaching:MaxConversationPerAgent' | abpLocalization }}
          </label>
          <input
            type="number"
            [min]="1"
            [max]="500"
            class="form-control form-control-sm"
            formControlName="aiCoachingMaxConversationCountPerAgent" />
          <small class="form-text text-muted ms-1">
            {{ 'Settings::AICoaching:MaxConversationPerAgent:Description' | abpLocalization }}
          </small>
        </div>
        <div class="form-group pt-3">
          <div class="d-flex align-items-center gap-2 mb-2">
            <label class="form-label mb-0 fw-semibold">
              {{ 'Settings::AICoaching:GoalKPIs:Title' | abpLocalization }}
            </label>
            <i
              class="fa fa-info-circle text-muted"
              [ngbTooltip]="'Settings::AICoaching:GoalKPIs:Tooltip' | abpLocalization"
              container="body"></i>
          </div>
          <table class="table table-sm table-borderless align-middle mb-1">
            <thead>
              <tr class="text-muted small text-uppercase border-bottom">
                <th style="width: 30%">{{ 'Settings::AICoaching:GoalKPIs:Column:KPI' | abpLocalization }}</th>
                <th style="width: 15%">{{ 'Settings::AICoaching:GoalKPIs:Column:Direction' | abpLocalization }}</th>
                <th style="width: 25%">{{ 'Settings::AICoaching:GoalKPIs:Column:GoalValue' | abpLocalization }}</th>
                <th style="width: 30%">{{ 'Settings::AICoaching:GoalKPIs:Column:Fallback' | abpLocalization }}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="border-bottom">
                <td>
                  <div class="fw-semibold small">{{ 'Settings::AICoaching:GoalKPIs:AvgCallDuration' | abpLocalization }}</div>
                  <div class="text-muted" style="font-size:0.75rem">{{ 'Settings::AICoaching:GoalKPIs:AvgCallDuration:Description' | abpLocalization }}</div>
                </td>
                <td><span class="badge bg-danger">&le; {{ '::Max' | abpLocalization }}</span></td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <input type="text" inputmode="decimal" class="form-control form-control-sm" style="width:90px" formControlName="aiCoachingGoalKpiAvgCallDuration" placeholder="e.g. 180" />
                    <span class="text-muted small">sec</span>
                  </div>
                </td>
                <td class="text-muted fst-italic small">{{ orgAverages?.avgCallDurationSec | number:'1.0-1' }} sec ({{ 'Settings::AICoaching:GoalKPIs:OrganizationAverage' | abpLocalization }})</td>
              </tr>
              <tr class="border-bottom">
                <td>
                  <div class="fw-semibold small">{{ 'Settings::AICoaching:GoalKPIs:AvgSilenceRatio' | abpLocalization }}</div>
                  <div class="text-muted" style="font-size:0.75rem">{{ 'Settings::AICoaching:GoalKPIs:AvgSilenceRatio:Description' | abpLocalization }}</div>
                </td>
                <td><span class="badge bg-danger">&le; {{ '::Max' | abpLocalization }}</span></td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <input type="text" inputmode="decimal" class="form-control form-control-sm" style="width:90px" formControlName="aiCoachingGoalKpiAvgSilenceRatio" placeholder="e.g. 10" />
                    <span class="text-muted small">%</span>
                  </div>
                </td>
                <td class="text-muted fst-italic small">{{ orgAverages?.avgSilenceRatio | number:'1.0-1' }}% ({{ 'Settings::AICoaching:GoalKPIs:OrganizationAverage' | abpLocalization }})</td>
              </tr>
              <tr class="border-bottom">
                <td>
                  <div class="fw-semibold small">{{ 'Settings::AICoaching:GoalKPIs:AvgCustomerShare' | abpLocalization }}</div>
                  <div class="text-muted" style="font-size:0.75rem">{{ 'Settings::AICoaching:GoalKPIs:AvgCustomerShare:Description' | abpLocalization }}</div>
                </td>
                <td><span class="badge bg-success">&ge; {{ '::Min' | abpLocalization }}</span></td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <input type="text" inputmode="decimal" class="form-control form-control-sm" style="width:90px" formControlName="aiCoachingGoalKpiAvgCustomerShare" placeholder="e.g. 40" />
                    <span class="text-muted small">%</span>
                  </div>
                </td>
                <td class="text-muted fst-italic small">{{ orgAverages?.avgCustomerShare | number:'1.0-1' }}% ({{ 'Settings::AICoaching:GoalKPIs:OrganizationAverage' | abpLocalization }})</td>
              </tr>
              <tr class="border-bottom">
                <td>
                  <div class="fw-semibold small">{{ 'Settings::AICoaching:GoalKPIs:AvgHoldCount' | abpLocalization }}</div>
                  <div class="text-muted" style="font-size:0.75rem">{{ 'Settings::AICoaching:GoalKPIs:AvgHoldCount:Description' | abpLocalization }}</div>
                </td>
                <td><span class="badge bg-danger">&le; {{ '::Max' | abpLocalization }}</span></td>
                <td>
                  <input type="text" inputmode="decimal" class="form-control form-control-sm" style="width:90px" formControlName="aiCoachingGoalKpiAvgHoldCount" placeholder="e.g. 2" />
                </td>
                <td class="text-muted fst-italic small">{{ orgAverages?.avgHoldCount | number:'1.0-1' }} ({{ 'Settings::AICoaching:GoalKPIs:OrganizationAverage' | abpLocalization }})</td>
              </tr>
              <tr class="border-bottom">
                <td>
                  <div class="fw-semibold small">{{ 'Settings::AICoaching:GoalKPIs:AvgAgentMonologueRatio' | abpLocalization }}</div>
                  <div class="text-muted" style="font-size:0.75rem">{{ 'Settings::AICoaching:GoalKPIs:AvgAgentMonologueRatio:Description' | abpLocalization }}</div>
                </td>
                <td><span class="badge bg-danger">&le; {{ '::Max' | abpLocalization }}</span></td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <input type="text" inputmode="decimal" class="form-control form-control-sm" style="width:90px" formControlName="aiCoachingGoalKpiAvgAgentMonologueRatio" placeholder="e.g. 30" />
                    <span class="text-muted small">%</span>
                  </div>
                </td>
                <td class="text-muted fst-italic small">{{ orgAverages?.avgAgentMonologueRatio | number:'1.0-1' }}% ({{ 'Settings::AICoaching:GoalKPIs:OrganizationAverage' | abpLocalization }})</td>
              </tr>
              <tr class="border-bottom">
                <td>
                  <div class="fw-semibold small">{{ 'Settings::AICoaching:GoalKPIs:AvgAgentSpeed' | abpLocalization }}</div>
                  <div class="text-muted" style="font-size:0.75rem">{{ 'Settings::AICoaching:GoalKPIs:AvgAgentSpeed:Description' | abpLocalization }}</div>
                </td>
                <td><span class="badge bg-danger">&le; {{ '::Max' | abpLocalization }}</span></td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <input type="text" inputmode="decimal" class="form-control form-control-sm" style="width:90px" formControlName="aiCoachingGoalKpiAvgAgentSpeed" placeholder="e.g. 15" />
                    <span class="text-muted small">l/s</span>
                  </div>
                </td>
                <td class="text-muted fst-italic small">{{ orgAverages?.avgAgentSpeedLettersSec | number:'1.0-1' }} l/s ({{ 'Settings::AICoaching:GoalKPIs:OrganizationAverage' | abpLocalization }})</td>
              </tr>
              <tr>
                <td>
                  <div class="fw-semibold small">{{ 'Settings::AICoaching:GoalKPIs:AvgAgentInterruptions' | abpLocalization }}</div>
                  <div class="text-muted" style="font-size:0.75rem">{{ 'Settings::AICoaching:GoalKPIs:AvgAgentInterruptions:Description' | abpLocalization }}</div>
                </td>
                <td><span class="badge bg-danger">&le; {{ '::Max' | abpLocalization }}</span></td>
                <td>
                  <div class="d-flex align-items-center gap-1">
                    <input type="text" inputmode="decimal" class="form-control form-control-sm" style="width:90px" formControlName="aiCoachingGoalKpiAvgAgentInterruptions" placeholder="e.g. 1" />
                    <span class="text-muted small">/min</span>
                  </div>
                </td>
                <td class="text-muted fst-italic small">{{ orgAverages?.avgAgentInterruptionPerMin | number:'1.0-2' }}/min ({{ 'Settings::AICoaching:GoalKPIs:OrganizationAverage' | abpLocalization }})</td>
              </tr>
            </tbody>
          </table>
          <small class="form-text text-muted ms-1">
            <i class="fa fa-info-circle"></i>
            {{ 'Settings::AICoaching:GoalKPIs:FooterNote' | abpLocalization }}
          </small>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #dropdownTemplate let-item="item">
  <span>{{ item.name }}</span>
</ng-template>

<ng-template #dropdownExceptTemplate let-item="item">
  {{ '::AllExcept' | abpLocalization: item.name }}
</ng-template>

<ng-template #dropdownAgentTemplate let-item="item">
  <span>{{ item.fullname }}</span>
</ng-template>

<ng-template #dropdownExceptAgentTemplate let-item="item">
  {{ '::AllExcept' | abpLocalization: item.fullname }}
</ng-template>

<ng-template #dropdownListSelectionTemplate let-selection="selection">
  {{ selection.name }}
</ng-template>

<ng-template #dropdownSelectionTemplate let-selection="selection">
  <div [ngbTooltip]="selection.name" container="body" style="display: inline">
    {{
      selection.length === 1
        ? selection[0].name
        : ('::XItemsSelected' | abpLocalization: selection.length)
    }}
  </div>
</ng-template>
